import { FC } from "react";
import styles from "./AssetCard.module.scss";
import { ICardData } from "../../pages/AssetsPage/AssetsTypes";

interface IAssetCardProps extends ICardData {};

export const AssetCard: FC<IAssetCardProps> = ({ title, description, icon, colorClass, context }) => {
    return (
        <div className={`${styles.card} ${styles[colorClass]} ${context ? '' : styles.innactive}`}>
            <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>
                    {title}
                </h3>

                <p className={styles.cardDescription}>
                    {description}
                </p>
            </div>
            
            <img
                src={icon}
                alt={title}
                className={styles.cardIcon}
            />
        </div>
    );
};
